var map = {
	"./1.svg": 18937,
	"./2.svg": 96173,
	"./arrow-up-down.svg": 81923,
	"./arrow-white.svg": 14913,
	"./arrow.svg": 83641,
	"./briefcase.svg": 25277,
	"./bxs-copy.svg": 47836,
	"./calendar.svg": 64674,
	"./cart.svg": 52006,
	"./chat.svg": 12847,
	"./check-bordered.svg": 40873,
	"./check-delivery-history-timeline.svg": 43762,
	"./check-delivery-timeline.svg": 52638,
	"./check-gray.svg": 94150,
	"./check-green.svg": 72028,
	"./check-white.svg": 2171,
	"./check.svg": 85384,
	"./checked.svg": 80758,
	"./chevron-left.svg": 46119,
	"./chevron-right-bargaining.svg": 63501,
	"./chevron-right.svg": 40395,
	"./clock.svg": 23826,
	"./close-red.svg": 91595,
	"./close.svg": 34241,
	"./coins.svg": 96677,
	"./comment.svg": 11978,
	"./danger.svg": 71523,
	"./delete.svg": 23776,
	"./details.svg": 28088,
	"./dots.svg": 3842,
	"./double-arrow-down.svg": 42728,
	"./double-arrow-up.svg": 91260,
	"./double-chevron-left.svg": 63725,
	"./double-chevron-right.svg": 33946,
	"./down-circle-black.svg": 38432,
	"./down-circle.svg": 11834,
	"./down.svg": 5495,
	"./edit-cancel.svg": 62577,
	"./edit-save.svg": 98475,
	"./edit.svg": 59945,
	"./error-notification.svg": 74192,
	"./error.svg": 84647,
	"./exchange.svg": 82267,
	"./exit.svg": 60187,
	"./eye-closed.svg": 36564,
	"./eye-off.svg": 66313,
	"./eye-opened.svg": 70925,
	"./eye.svg": 14171,
	"./eye2.svg": 73650,
	"./filter-burger.svg": 98510,
	"./flag/ae.svg": 61474,
	"./flag/af.svg": 59370,
	"./flag/ag.svg": 72709,
	"./flag/al.svg": 91366,
	"./flag/am.svg": 5536,
	"./flag/ao.svg": 26075,
	"./flag/aq.svg": 40114,
	"./flag/ar.svg": 12924,
	"./flag/as.svg": 2468,
	"./flag/at.svg": 56696,
	"./flag/au.svg": 1181,
	"./flag/ax.svg": 26771,
	"./flag/az.svg": 73945,
	"./flag/ba.svg": 90656,
	"./flag/bb.svg": 10038,
	"./flag/bd.svg": 74662,
	"./flag/be.svg": 89814,
	"./flag/bf.svg": 12798,
	"./flag/bg.svg": 53132,
	"./flag/bh.svg": 22993,
	"./flag/bi.svg": 41256,
	"./flag/bj.svg": 11773,
	"./flag/bl.svg": 67680,
	"./flag/bn.svg": 43559,
	"./flag/bq.svg": 96432,
	"./flag/br.svg": 98226,
	"./flag/bs.svg": 40171,
	"./flag/bv.svg": 77998,
	"./flag/bw.svg": 75240,
	"./flag/by.svg": 45595,
	"./flag/ca.svg": 94359,
	"./flag/cc.svg": 5387,
	"./flag/cd.svg": 59589,
	"./flag/cf.svg": 47723,
	"./flag/cg.svg": 18334,
	"./flag/ch.svg": 13714,
	"./flag/ci.svg": 35481,
	"./flag/ck.svg": 63748,
	"./flag/cl.svg": 55464,
	"./flag/cm.svg": 60296,
	"./flag/cn.svg": 35477,
	"./flag/co.svg": 98908,
	"./flag/cr.svg": 34143,
	"./flag/cu.svg": 2747,
	"./flag/cv.svg": 12177,
	"./flag/cw.svg": 26134,
	"./flag/cx.svg": 69741,
	"./flag/cy.svg": 93832,
	"./flag/cz.svg": 75666,
	"./flag/de.svg": 96122,
	"./flag/dj.svg": 16133,
	"./flag/dk.svg": 4582,
	"./flag/dz.svg": 14565,
	"./flag/ee.svg": 72080,
	"./flag/eg.svg": 54265,
	"./flag/eh.svg": 12706,
	"./flag/er.svg": 35985,
	"./flag/es-ct.svg": 26291,
	"./flag/es.svg": 75930,
	"./flag/et.svg": 63651,
	"./flag/eu.svg": 3811,
	"./flag/fi.svg": 9609,
	"./flag/flag-1.svg": 29677,
	"./flag/flag-2.svg": 43038,
	"./flag/flag-3.svg": 35108,
	"./flag/flag-4.svg": 73538,
	"./flag/flag-5.svg": 64841,
	"./flag/flag-6.svg": 72729,
	"./flag/fm.svg": 73085,
	"./flag/fo.svg": 19862,
	"./flag/fr.svg": 42252,
	"./flag/ga.svg": 2806,
	"./flag/gb-eng.svg": 23099,
	"./flag/gb-sct.svg": 97609,
	"./flag/gb-wls.svg": 49815,
	"./flag/gb.svg": 96916,
	"./flag/gd.svg": 28999,
	"./flag/ge.svg": 86983,
	"./flag/gf.svg": 30744,
	"./flag/gg.svg": 17890,
	"./flag/gh.svg": 34628,
	"./flag/gi.svg": 68988,
	"./flag/gl.svg": 29669,
	"./flag/gm.svg": 78990,
	"./flag/gn.svg": 49761,
	"./flag/gp.svg": 84518,
	"./flag/gq.svg": 42706,
	"./flag/gr.svg": 61440,
	"./flag/gu.svg": 32827,
	"./flag/gw.svg": 64297,
	"./flag/gy.svg": 1924,
	"./flag/hk.svg": 70578,
	"./flag/hm.svg": 73106,
	"./flag/hn.svg": 57758,
	"./flag/hu.svg": 13810,
	"./flag/id.svg": 64249,
	"./flag/ie.svg": 82188,
	"./flag/il.svg": 96253,
	"./flag/im.svg": 26367,
	"./flag/in.svg": 76716,
	"./flag/iq.svg": 75939,
	"./flag/is.svg": 1237,
	"./flag/it.svg": 87344,
	"./flag/je.svg": 96831,
	"./flag/jm.svg": 87416,
	"./flag/jo.svg": 33415,
	"./flag/jp.svg": 57200,
	"./flag/ke.svg": 5639,
	"./flag/kg.svg": 18367,
	"./flag/kh.svg": 238,
	"./flag/ki.svg": 84381,
	"./flag/km.svg": 59696,
	"./flag/kn.svg": 57437,
	"./flag/kp.svg": 85298,
	"./flag/kr.svg": 48908,
	"./flag/kw.svg": 77002,
	"./flag/kz.svg": 72667,
	"./flag/la.svg": 31591,
	"./flag/lb.svg": 53453,
	"./flag/lc.svg": 98773,
	"./flag/li.svg": 44162,
	"./flag/lk.svg": 3028,
	"./flag/lr.svg": 10849,
	"./flag/ls.svg": 841,
	"./flag/lt.svg": 57352,
	"./flag/lu.svg": 81996,
	"./flag/lv.svg": 90068,
	"./flag/ly.svg": 60352,
	"./flag/ma.svg": 35849,
	"./flag/mc.svg": 88866,
	"./flag/mf.svg": 24510,
	"./flag/mg.svg": 58995,
	"./flag/mh.svg": 55268,
	"./flag/mk.svg": 81267,
	"./flag/ml.svg": 1570,
	"./flag/mm.svg": 34284,
	"./flag/mn.svg": 31436,
	"./flag/mo.svg": 84844,
	"./flag/mq.svg": 87753,
	"./flag/mr.svg": 86679,
	"./flag/ms.svg": 41541,
	"./flag/mt.svg": 48303,
	"./flag/mu.svg": 6171,
	"./flag/mv.svg": 93868,
	"./flag/mw.svg": 11835,
	"./flag/my.svg": 97271,
	"./flag/mz.svg": 31590,
	"./flag/na.svg": 45237,
	"./flag/nc.svg": 45619,
	"./flag/ne.svg": 91635,
	"./flag/nf.svg": 89965,
	"./flag/ng.svg": 36535,
	"./flag/ni.svg": 4363,
	"./flag/nl.svg": 36832,
	"./flag/no.svg": 59323,
	"./flag/np.svg": 66703,
	"./flag/nr.svg": 50972,
	"./flag/nu.svg": 91643,
	"./flag/nz.svg": 41710,
	"./flag/pa.svg": 11606,
	"./flag/pf.svg": 28008,
	"./flag/pg.svg": 87798,
	"./flag/ph.svg": 44357,
	"./flag/pk.svg": 60114,
	"./flag/pl.svg": 73461,
	"./flag/pm.svg": 64467,
	"./flag/pn.svg": 60146,
	"./flag/pr.svg": 36945,
	"./flag/ps.svg": 96871,
	"./flag/pt.svg": 59842,
	"./flag/pw.svg": 32456,
	"./flag/py.svg": 99510,
	"./flag/qa.svg": 51887,
	"./flag/re.svg": 88632,
	"./flag/ro.svg": 41986,
	"./flag/ru.svg": 91426,
	"./flag/rus.svg": 23047,
	"./flag/rw.svg": 3485,
	"./flag/sa.svg": 29062,
	"./flag/sb.svg": 12125,
	"./flag/sc.svg": 80476,
	"./flag/sd.svg": 28766,
	"./flag/se.svg": 76436,
	"./flag/sg.svg": 38641,
	"./flag/si.svg": 96127,
	"./flag/sj.svg": 69933,
	"./flag/sk.svg": 39032,
	"./flag/sl.svg": 44916,
	"./flag/so.svg": 85311,
	"./flag/sr.svg": 37321,
	"./flag/ss.svg": 64982,
	"./flag/st.svg": 12498,
	"./flag/sx.svg": 43019,
	"./flag/sy.svg": 36531,
	"./flag/sz.svg": 30143,
	"./flag/td.svg": 81689,
	"./flag/tf.svg": 60037,
	"./flag/tg.svg": 4199,
	"./flag/th.svg": 50719,
	"./flag/tj.svg": 38142,
	"./flag/tk.svg": 71773,
	"./flag/tl.svg": 30938,
	"./flag/tn.svg": 84753,
	"./flag/to.svg": 94957,
	"./flag/tr.svg": 99733,
	"./flag/tt.svg": 39232,
	"./flag/tv.svg": 69595,
	"./flag/tw.svg": 52404,
	"./flag/tz.svg": 95409,
	"./flag/ua.svg": 98371,
	"./flag/ug.svg": 95029,
	"./flag/um.svg": 63237,
	"./flag/un.svg": 18388,
	"./flag/us.svg": 54095,
	"./flag/uy.svg": 20049,
	"./flag/uz.svg": 49125,
	"./flag/vc.svg": 2450,
	"./flag/ve.svg": 48173,
	"./flag/vi.svg": 45301,
	"./flag/vn.svg": 45240,
	"./flag/vu.svg": 15945,
	"./flag/wf.svg": 2965,
	"./flag/ws.svg": 79287,
	"./flag/xk.svg": 23303,
	"./flag/ye.svg": 71706,
	"./flag/yt.svg": 31472,
	"./flag/za.svg": 28321,
	"./flag/zm.svg": 68198,
	"./flag/zw.svg": 11767,
	"./handshake.svg": 3830,
	"./icon-sale.svg": 13376,
	"./in-progress.svg": 13522,
	"./inbox.svg": 2828,
	"./info.svg": 59519,
	"./info2.svg": 24764,
	"./inprogress-notification.svg": 84258,
	"./kan.svg": 26144,
	"./line-chart.svg": 85513,
	"./list-checks.svg": 5545,
	"./list.svg": 10051,
	"./location.svg": 40834,
	"./lock-closed.svg": 79474,
	"./magnifying-glass.svg": 81760,
	"./mail.svg": 50913,
	"./map-marker.svg": 18478,
	"./map-pin-house.svg": 56469,
	"./maximize.svg": 8503,
	"./megaphone.svg": 3276,
	"./message-colored.svg": 10805,
	"./message.svg": 25656,
	"./minus.svg": 33704,
	"./notifications.svg": 3778,
	"./paperclip.svg": 9980,
	"./pdf.svg": 87176,
	"./phone.svg": 63980,
	"./picture-f.svg": 32173,
	"./plus-gray.svg": 33717,
	"./plus.svg": 74132,
	"./plus2.svg": 57771,
	"./popup-item-close.svg": 46009,
	"./purse.svg": 38253,
	"./refresh.svg": 30709,
	"./remove.svg": 80810,
	"./reset.svg": 18854,
	"./search.svg": 96962,
	"./select.svg": 35520,
	"./settings.svg": 69530,
	"./share.svg": 16641,
	"./shopping-bag.svg": 61519,
	"./star-rating.svg": 15912,
	"./star.svg": 24281,
	"./success-notification.svg": 94791,
	"./success.svg": 57781,
	"./tags.svg": 73288,
	"./team.svg": 91315,
	"./telegram.svg": 98407,
	"./tile.svg": 45258,
	"./truck.svg": 39240,
	"./unarchive.svg": 1062,
	"./uncheck.svg": 56251,
	"./up-circle.svg": 80392,
	"./up.svg": 3089,
	"./verified.svg": 56408,
	"./visibility-off.svg": 39778,
	"./visibility-on.svg": 32694,
	"./wallet.svg": 23219,
	"./warehouse.svg": 20259,
	"./x-mark.svg": 38838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20866;